export default "__VITE_ASSET__Cg$6jafk__"